"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f228 = void 0;
exports.f228 = {
    "äkäyöñ": [
        3749
    ],
    "äiwoo": [
        5417
    ],
    "älvdalska": [
        6004
    ],
    "älvdalsmålet": [
        6004
    ]
};
